import { createContext } from 'react';

export interface AuthHandlerCtx {
  handleUnauthorized: () => void;
}

export const AuthHandlerContext = createContext<AuthHandlerCtx | null>(null);
